import { useMemo, useState } from "react";
import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

export const KINDS = { REELS: "Reel", FEED: "Post e caroselli", STORY: "Storie", FB_POST: "Post Facebook" };
const eng = (m) => m.insights?.total_interactions ?? ((m.insights?.likes || 0) + (m.insights?.comments || 0) + (m.insights?.saved || 0) + (m.insights?.shares || 0));

const Item = ({ m }) => (
  <a href={m.permalink} target="_blank" rel="noreferrer" className="flex items-center gap-3 border-b border-border/40 py-2 text-sm last:border-0 hover:bg-secondary/30" data-testid={`social-media-${m.id}`}>
    <img src={m.thumbnail_url || m.media_url} alt="" className="h-12 w-12 shrink-0 rounded object-cover" />
    <div className="min-w-0 flex-1">
      <p className="truncate">{m.caption?.split("\n")[0] || "(senza testo)"}</p>
      <p className="text-xs text-muted-foreground">{KINDS[m.kind]} · {new Date(m.timestamp).toLocaleDateString("it-IT")}</p>
    </div>
    <div className="shrink-0 text-right text-xs">
      <p><span className="font-semibold">{num(m.insights?.reach)}</span> raggiunti</p>
      <p className="text-muted-foreground">{num(eng(m))} interazioni · {num(m.insights?.saved)} salvati</p>
    </div>
    <ExternalLink className="hidden h-3.5 w-3.5 text-muted-foreground md:block" />
  </a>
);

export const SocialTopMedia = ({ media }) => {
  const [kind, setKind] = useState("tutti");
  const [sort, setSort] = useState("reach");
  const list = useMemo(() => media
    .filter((m) => kind === "tutti" || m.kind === kind)
    .sort((a, b) => (sort === "reach" ? (b.insights?.reach || 0) - (a.insights?.reach || 0) : eng(b) - eng(a))), [media, kind, sort]);
  return (
    <Card className="p-5" data-testid="social-top-media">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-display text-lg font-semibold">Contenuti del periodo</h3>
        <div className="flex flex-wrap gap-1.5">
          {[["tutti", "Tutti"], ...Object.entries(KINDS)].map(([k, l]) => (
            <Button key={k} size="sm" variant={kind === k ? "default" : "outline"} className="h-7 rounded-full text-xs" onClick={() => setKind(k)} data-testid={`social-kind-${k}`}>{l}</Button>
          ))}
          <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setSort(sort === "reach" ? "eng" : "reach")} data-testid="social-sort">
            Ordina per: {sort === "reach" ? "copertura" : "interazioni"}
          </Button>
        </div>
      </div>
      <div className="max-h-[520px] overflow-auto">{list.map((m) => <Item key={m.id} m={m} />)}</div>
      {!list.length && <p className="text-sm text-muted-foreground" data-testid="social-media-empty">Nessun contenuto in questo periodo</p>}
    </Card>
  );
};

export { eng };
